import React from 'react';
import TextPlaceholder from 'components/shared/TextPlaceholder';
import CornerRibbon from 'components/_shared/corner_ribbon';
import CoverImage from 'components/shared/LibraryTopic/CoverImage';

const TopicCardPreview = ({ image }) => (
  <div className="LibraryTopic LibraryTopic--withImage">
    <CornerRibbon type="warning" icon="star_filled" />
    <CoverImage image={image} />
    <div className="LibraryTopic-content d-f jc-sb fd-c">
      <div>
        <TextPlaceholder minWidth={60} large />
        <TextPlaceholder minWidth={60} />
        <TextPlaceholder minWidth={60} />
        <TextPlaceholder minWidth={60} />
      </div>
      <div className="LibraryTopic-count">
        <TextPlaceholder />
      </div>
    </div>
  </div>
);

export default TopicCardPreview;
